<template>
  <div
    :class="isMobile ? 'p-l' : 'p-2xl'"
    class="sign-in w-lg-520px bg-white border-radius-s shadow-sm mx-auto mb-l"
  >
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BoxRegister',
  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
  },
};
</script>
